(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dg-announcements"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dg-announcements')) {
  customElements.define('dg-announcements', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-message]')];
      if (this.slides.length < 2 || this.bound) return;
      this.bound = true;
      this.index = 0;
      this.paused = this.dataset.auto !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.classList.add('is-ready');
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {this.show(this.index + Number(button.dataset.direction)); this.start();}, options));
      this.pause = this.querySelector('.dg-notice__pause');
      this.pause.addEventListener('click', () => {this.paused = !this.paused; this.sync(); this.start();}, options);
      this.addEventListener('mouseenter', () => this.stop(), options);
      this.addEventListener('mouseleave', () => this.start(), options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('focusout', () => this.start(), options);
      document.addEventListener('visibilitychange', () => this.start(), options);
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-message]');
        if (!slide || !this.contains(slide)) return;
        this.paused = true; this.show(this.slides.indexOf(slide)); this.sync(); this.stop();
      }, options);
      this.sync(); this.start();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {slide.hidden = i !== this.index;});
    }
    sync() {
      this.pause.setAttribute('aria-pressed', String(this.paused));
      this.pause.setAttribute('aria-label', this.paused ? this.pause.dataset.playLabel : this.pause.dataset.pauseLabel);
      this.pause.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
    }
    stop() {clearInterval(this.timer);}
    start() {
      this.stop();
      if (this.paused || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
      this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) * 1000);
    }
    disconnectedCallback() {this.stop(); this.abort?.abort(); this.bound = false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
